(() => {
  'use strict';

  const imageSelector = '.omnisend-form-6a069d13ab28a246322eff6c-image-6a0644bd4736cfd6053c0558';
  const checkboxSelector = 'input[type="checkbox"][name="gdpr"]';

  const initialize = () => {
    document.querySelectorAll('.picco-private-sales[data-picco-sale-image]').forEach((root) => {
      if (root.dataset.piccoSaleImageInitialized) return;
      root.dataset.piccoSaleImageInitialized = 'true';
      const imageUrl = root.dataset.piccoSaleImage;
      const initializedCheckboxes = new WeakSet();
      let checkboxChoice = true;

      root.addEventListener('change', (event) => {
        if (!event.target.matches(checkboxSelector)) return;
        checkboxChoice = event.target.checked;
        event.target.defaultChecked = checkboxChoice;
      });

      const replaceImage = () => {
        root.querySelectorAll(imageSelector).forEach((image) => {
          if (image.getAttribute('src') !== imageUrl) image.setAttribute('src', imageUrl);
          if (image.hasAttribute('srcset')) image.removeAttribute('srcset');
          image.alt = 'Picco Members-Only 10% Off. Subscribe to get early access and exclusive deals. Not cumulative with other promotions.';
        });
      };

      let pickerFrame = 0;
      const positionCountryMenus = () => {
        pickerFrame = 0;
        const bounds = root.getBoundingClientRect();
        const viewport = window.visualViewport;
        const viewportTop = viewport ? viewport.offsetTop : 0;
        const visibleTop = Math.max(bounds.top, viewportTop);
        const visibleBottom = Math.min(bounds.bottom, viewportTop + (viewport ? viewport.height : window.innerHeight));

        root.querySelectorAll('[role="combobox"][aria-expanded="true"]').forEach((combo) => {
          const wrapper = combo.parentElement;
          if (!wrapper.querySelector('[role="listbox"]')) return;
          const field = wrapper.getBoundingClientRect();
          const above = Math.max(0, field.top - visibleTop - 8);
          const below = Math.max(0, visibleBottom - field.bottom - 8);
          const openBelow = below >= 220 || below >= above;
          wrapper.dataset.piccoSalePickerDirection = openBelow ? 'below' : 'above';
          wrapper.style.setProperty('--picco-sale-picker-height', `${Math.floor(Math.min(220, openBelow ? below : above))}px`);
        });
      };
      const schedulePickerPosition = () => {
        if (!pickerFrame) pickerFrame = window.requestAnimationFrame(positionCountryMenus);
      };

      root.addEventListener('scroll', schedulePickerPosition, { passive: true });
      window.addEventListener('resize', schedulePickerPosition, { passive: true });
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', schedulePickerPosition, { passive: true });
        window.visualViewport.addEventListener('scroll', schedulePickerPosition, { passive: true });
      }

      const prepareForm = () => {
        replaceImage();
        root.querySelectorAll(checkboxSelector).forEach((checkbox) => {
          if (initializedCheckboxes.has(checkbox)) return;
          initializedCheckboxes.add(checkbox);
          if (checkbox.checked !== checkboxChoice) checkbox.click();
          checkbox.defaultChecked = checkboxChoice;
        });
        schedulePickerPosition();
      };

      const observer = new MutationObserver(prepareForm);
      observer.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['src', 'srcset', 'aria-expanded']
      });
      prepareForm();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', initialize);
})();
